import SettingsRouter from './Settings.router';

export default SettingsRouter;
